export const FETCH_RATES_SUCCESS = 'FETCH_RATES_SUCCESS';
export const FETCH_RATES_REQUEST = 'FETCH_RATES_REQUEST';
export const FETCH_RATES_FAILURE = 'FETCH_RATES_FAILURE';
export const FETCH_RATES_RESET = 'FETCH_RATES_RESET';
export const fetchRatesSuccess = (payload) => ({
    type: FETCH_RATES_SUCCESS,
    payload,
});
export const fetchRatesRequest = (payload) => ({
    type: FETCH_RATES_REQUEST,
    payload,
});
export const fetchRatesFailure = (error) => ({
    type: FETCH_RATES_FAILURE,
    payload: error,
});
export const fetchRatesReset = () => ({
    type: FETCH_RATES_RESET,
});
